import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CampaignHeaderProps {
  packageName?: string;
  placementWindow?: {
    start_date: string;
    end_date: string;
  };
  campaignId?: string;
  onPlaceHold?: () => void;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({
  packageName = "test",
  placementWindow,
  campaignId,
  onPlaceHold
}) => {
  const backLink = campaignId ? `/campaigns/${campaignId}/package-ready` : "/brand-dashboard";
  
  return (
    <div>
      {/* Back Link */}
      <Link
        to={backLink}
        className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-6 transition-colors"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        CAMPAIGN OVERVIEW
      </Link>

      {/* Package Header */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-4xl font-bold text-foreground mb-2">
            {packageName}
          </h1>
          {placementWindow && (
            <p className="text-muted-foreground">
              Placements expected live: {
                placementWindow.start_date && !isNaN(new Date(placementWindow.start_date).getTime())
                  ? new Date(placementWindow.start_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
                  : 'TBD'
              } - {
                placementWindow.end_date && !isNaN(new Date(placementWindow.end_date).getTime())
                  ? new Date(placementWindow.end_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                  : 'TBD'
              }
            </p>
          )}
        </div>
        <div className="flex gap-3">
          <Button
            variant="outline"
            className="hover:bg-neutral-50 hover:border-neutral-400 transition-all duration-200"
            onClick={() => {
              // Export functionality - generate and download one-sheet
              const packageData = {
                campaignName: packageName || 'Campaign',
                placementWindow: placementWindow ? {
                  start: placementWindow.start_date && !isNaN(new Date(placementWindow.start_date).getTime())
                    ? new Date(placementWindow.start_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                    : 'TBD',
                  end: placementWindow.end_date && !isNaN(new Date(placementWindow.end_date).getTime())
                    ? new Date(placementWindow.end_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                    : 'TBD'
                } : null
              };
              
              // Create and download CSV
              const csvContent = [
                ['Campaign One-Sheet'],
                ['Campaign Name', packageData.campaignName],
                ['Placement Window', packageData.placementWindow ? `${packageData.placementWindow.start} - ${packageData.placementWindow.end}` : 'TBD'],
                ['Generated On', new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })],
                [],
                ['For more details, please contact support@artie.com']
              ].map(row => row.join(',')).join('\n');
              
              const blob = new Blob([csvContent], { type: 'text/csv' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${packageData.campaignName.replace(/[^a-zA-Z0-9]/g, '_')}_one_sheet.csv`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }}
          >
            Export One-Sheet
          </Button>
          <Button
            onClick={onPlaceHold}
            className="bg-foreground text-background hover:bg-foreground/90 transition-colors duration-200"
          >
            Place Hold on Package
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CampaignHeader;